import withParams from "@src/components/widgets/HOC/withParams";
import React from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetHeaderParams } from "../interface";
import JsonPrint from "@src/utils/JsonPrint";
import Typography from "design-system/src/Foundation/Typography/Typography";

const LandingStandardDebug: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetHeaderParams>((props) => {
    const { params } = props;

    return (
      <Typography as="div">
        <JsonPrint object={params} />
      </Typography>
    );
  });

export default LandingStandardDebug;
